import { render } from "./MantissSnek.vue?vue&type=template&id=58fde8ed&ts=true"
import script from "./MantissSnek.vue?vue&type=script&lang=ts"
export * from "./MantissSnek.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Domingos\\Documents\\GitHub\\staking-fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__